import React, { createContext, useState, useContext, useEffect } from 'react';

// Comprehensive theme configuration for light and dark modes
export const mo3tiThemes = {
  dark: {
    colors: {
      primary: "#3b82f6",
      primary1: "#ffffffff",

      primaryDark: "#2563eb",
      secondary: "#6366f1",
      success: "#10b981",
      warning: "#f59e0b",
      danger: "#ef4444",
      info: "#06b6d4",
      textPrimary: "#ffffff",
      textSecondary: "rgba(255, 255, 255, 0.8)",
      textMuted: "rgba(255, 255, 255, 0.6)",
      border: "rgba(255, 255, 255, 0.1)",
      borderLight: "rgba(255, 255, 255, 0.05)",
      cardBackground: "rgba(255, 255, 255, 0.01)",
      sidebarBackground: "rgba(255, 255, 255, 0.05)",
      topbarBackground: "rgba(255, 255, 255, 0.05)",
      inputBackground: "rgba(255, 255, 255, 0.1)",
      hoverBackground: "rgba(255, 255, 255, 0.1)",
      activeBackground: "rgba(59, 130, 246, 0.2)",
      scrollbar: {
        track: "rgba(255, 255, 255, 0.1)",
        thumb: "rgba(255, 255, 255, 0.3)",
        thumbHover: "rgba(255, 255, 255, 0.5)"
      }
    },
    
    background: {
      gradient: "linear-gradient(135deg, #0b1530 10%, #0d1b3a 100%)",
      overlay: {
        position: "absolute",
        inset: "0",
        backgroundSize: "cover",
        backgroundPosition: "center",
        opacity: 0.3,
        pointerEvents: "none"
      },
      overlay1: {
        position: "absolute",
        inset: "0",
        backgroundImage: "rgba(15, 23, 42, 0.95)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        opacity: 0.3,
        pointerEvents: "none"
      },
      decorative: {
        container: {
          position: "absolute",
          inset: "0",
          overflow: "hidden",
          pointerEvents: "none"
        },
        circle1: {
          position: "absolute",
          top: "-140px",
          right: "-120px",
          width: "300px",
          height: "300px",
          background: "rgba(99, 102, 241, 0.1)",
          borderRadius: "50%",
          filter: "blur(60px)"
        },
        circle2: {
          position: "absolute",
          bottom: "-140px",
          left: "-140px",
          width: "320px",
          height: "320px",
          background: "rgba(59, 130, 246, 0.1)",
          borderRadius: "50%",
          filter: "blur(60px)"
        }
      }
    },
    shadows: {
      card: "0 8px 32px rgba(0, 0, 0, 0.2)",
      button: "0 4px 15px rgba(59, 130, 246, 0.3)",
      sidebar: "2px 0 20px rgba(0, 0, 0, 0.3)"
    },
    shadows1: {
            gradient1: "rgba(15, 23, 42, 0.95)",

    },
    fonts: {
      primary: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
      sizes: {
        xs: "12px",
        sm: "14px",
        base: "16px",
        lg: "18px",
        xl: "20px",
        xxl: "24px",
        xxxl: "28px"
      },
      weights: {
        normal: "400",
        medium: "500",
        semibold: "600",
        bold: "700"
      }
    },
    branding: {
      container: {
        position: "absolute",
        right: "30px",
        bottom: "40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: "16px",
        padding: "8px",
        zIndex: 10
      },
      link: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        color: "#ffffff",
        fontSize: "16px",
        fontWeight: "600",
        textDecoration: "none",
        cursor: "pointer",
        padding: "12px 20px",
        background: "linear-gradient(135deg, #ef4444, #dc2626)",
        borderRadius: "12px",
        boxShadow: "0 4px 15px rgba(239, 68, 68, 0.3)",
        transition: "all 0.3s ease",
        textShadow: "0 1px 2px rgba(0,0,0,0.3)"
      }
    }
  },
  light: {
    colors: {
      primary1: "#000000ff",

      primary: "#2e7cba",
      primaryDark: "#1d4ed8",
      secondary: "#4f46e5",
      success: "#059669",
      warning: "#d97706",
      danger: "#dc2626",
      info: "#0891b2",
      textPrimary: "#1f2937",
      textSecondary: "#6b7280",
      textMuted: "#9ca3af",
      border: "rgba(0, 0, 0, 0.1)",
      borderLight: "rgba(0, 0, 0, 0.05)",
      cardBackground: "rgba(255, 255, 255, 0.9)",
      sidebarBackground: "rgba(255, 255, 255, 0.95)",
      topbarBackground: "rgba(255, 255, 255, 0.95)",
      inputBackground: "rgba(0, 0, 0, 0.05)",
      hoverBackground: "rgba(0, 0, 0, 0.05)",
      activeBackground: "rgba(37, 99, 235, 0.1)",
      scrollbar: {
        track: "rgba(0, 0, 0, 0.1)",
        thumb: "rgba(0, 0, 0, 0.3)",
        thumbHover: "rgba(0, 0, 0, 0.5)"
      }
    },
    background: {
      gradient: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
      overlay: {
        position: "absolute",
        inset: "0",
        backgroundSize: "cover",
        backgroundPosition: "center",
        opacity: 0.2,
        pointerEvents: "none"
      },
      decorative: {
        container: {
          position: "absolute",
          inset: "0",
          overflow: "hidden",
          pointerEvents: "none"
        },
        circle1: {
          position: "absolute",
          top: "-140px",
          right: "-120px",
          width: "300px",
          height: "300px",
          background: "rgba(37, 99, 235, 0.08)",
          borderRadius: "50%",
          filter: "blur(60px)"
        },
        circle2: {
          position: "absolute",
          bottom: "-140px",
          left: "-140px",
          width: "320px",
          height: "320px",
          background: "rgba(79, 70, 229, 0.08)",
          borderRadius: "50%",
          filter: "blur(60px)"
        }
      }
    },
    shadows: {
      card: "0 4px 16px rgba(0, 0, 0, 0.1)",
      button: "0 2px 8px rgba(37, 99, 235, 0.2)",
      sidebar: "2px 0 10px rgba(0, 0, 0, 0.1)"
    },
    fonts: {
      primary: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
      sizes: {
        xs: "12px",
        sm: "14px",
        base: "16px",
        lg: "18px",
        xl: "20px",
        xxl: "24px",
        xxxl: "28px"
      },
      weights: {
        normal: "400",
        medium: "500",
        semibold: "600",
        bold: "700"
      }
    },
    branding: {
      container: {
        position: "absolute",
        right: "30px",
        bottom: "40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: "16px",
        padding: "8px",
        zIndex: 10
      },
      link: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        color: "#ffffff",
        fontSize: "16px",
        fontWeight: "600",
        textDecoration: "none",
        cursor: "pointer",
        padding: "12px 20px",
        background: "linear-gradient(135deg, #dc2626, #b91c1c)",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(220, 38, 38, 0.3)",
        transition: "all 0.3s ease"
      }
    }
  }
};

// Utility functions for theme management
export const getThemeStyles = (theme) => ({
  card: {
    background: theme.colors.cardBackground,
    backdropFilter: "blur(25px)",
    border: `1px solid ${theme.colors.border}`,
    borderRadius: "20px",
    padding: "24px",
    boxShadow: theme.shadows.card,
    marginBottom: "24px"
  },
  button: {
    primary: {
      background: `linear-gradient(135deg, ${theme.colors.primary}, ${theme.colors.primaryDark})`,
      color: "#ffffff",
      border: "none",
      padding: "12px 24px",
      borderRadius: "12px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      fontSize: theme.fonts.sizes.sm,
      fontWeight: theme.fonts.weights.semibold,
      boxShadow: theme.shadows.button
    },
    secondary: {
      background: theme.colors.inputBackground,
      color: theme.colors.textPrimary,
      border: `1px solid ${theme.colors.border}`,
      padding: "12px 24px",
      borderRadius: "12px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      fontSize: theme.fonts.sizes.sm,
      fontWeight: theme.fonts.weights.medium
    }
  },
  input: {
    background: theme.colors.inputBackground,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: "12px",
    padding: "12px 16px",
    color: theme.colors.textPrimary,
    fontSize: theme.fonts.sizes.sm,
    outline: "none",
    transition: "all 0.3s ease"
  }
});

// Theme Context
const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('mo3ti-theme');
    return savedTheme || 'dark';
  });

  const isDarkMode = theme === 'dark';
  const currentTheme = mo3tiThemes[theme];

  useEffect(() => {
    localStorage.setItem('mo3ti-theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
    document.body.className = `theme-${theme}`;
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light');
  };

  const value = {
    theme,
    setTheme,
    toggleTheme,
    isDarkMode,
    currentTheme,
    colors: currentTheme.colors,
    background: currentTheme.background,
    shadows: currentTheme.shadows,
    fonts: currentTheme.fonts,
    getThemeStyles: () => getThemeStyles(currentTheme)
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export { ThemeContext };
export default mo3tiThemes;







































































































